// default values (can be 1 || 2 or 0 || 2)
// 'permissionTestBatteries'              => 1,
// 'permissionJobs'                       => 1,
// 'permissionCandidates'                 => 0,
// 'permissionTestMaker'                  => 1,
// 'permissionApplications'               => 1,
// 'permissionLandingPage'                => 1,
// 'permissionExitPage'                   => 1,
// 'permissionDocuments'                  => 1,
// 'permissionEmailTemplate'              => 1,
// 'permissionPipelines'                  => 1,
// 'permissionIntegrations'               => 0,
// 'permissionRoles'                      => 0,
// 'permissionUserManagement'             => 0,
// 'permissionCompanySettings'            => 0,
// 'permissionBillingSettings'            => 0,
// 'permissionRatings'                    => 1,
// 'permissionBaselines'                  => 1,
// 'permissionLabels'                     => 0,
// 'permissionMoveCandidates'             => 0,
// 'permissionAnalytics'                  => 0,
// 'permissionVideoInterviewTemplates'    => 1,
// 'permissionCompetencySets'             => 0

export const RolesAccessLibrary = (roles, roleId = null) => {
  const accessRole =
    roles.size > 0 && roleId ? roles.get(String(roleId)) : null;
  return {
    jobsPermission: () =>
      accessRole === null ? false : accessRole.get("permissionJobs") === 2,
    resultsPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionCandidates") === 1,
    moveEmailCandidatesPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionMoveCandidates") === 2,
    baselinesPermission: () =>
      accessRole === null ? false : accessRole.get("permissionBaselines") === 2,
    batteriesPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionTestBatteries") === 2,
    analyticsPermission: () =>
      accessRole === null ? false : accessRole.get("permissionAnalytics") === 2,
    usersTeamsPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionUserManagement") === 2,
    accessRolesPermission: () =>
      accessRole === null ? false : accessRole.get("permissionRoles") === 2,
    companyPrefPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionCompanySettings") === 2,
    integrationsPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionIntegrations") === 2,
    documentsPermission: () =>
      accessRole === null ? false : accessRole.get("permissionDocuments") === 2,
    testMakerPermission: () =>
      accessRole === null ? false : accessRole.get("permissionTestMaker") === 2,
    jobAppsPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionApplications") === 2,
    pipelinesPermission: () =>
      accessRole === null ? false : accessRole.get("permissionPipelines") === 2,
    emailTemplatesPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionEmailTemplate") === 2,
    ratingSystemsPermission: () =>
      accessRole === null ? false : accessRole.get("permissionRatings") === 2,
    landingPagesPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionLandingPage") === 2,
    exitPagesPermission: () =>
      accessRole === null ? false : accessRole.get("permissionExitPage") === 2,
    collaboratorOnlyPermission: () =>
      accessRole === null ? false : accessRole.get("roleId") === 4,
    interviewTemplatesPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionVideoInterviewTemplates") === 2,
    competencySetsPermission: () =>
      accessRole === null
        ? false
        : accessRole.get("permissionCompetencySets") === 2,
    accountBillingDetailsPagePermission: () =>
      accessRole === null ? false : accessRole.get("roleId") === 1,
  };
};
export const getAllPermissions = (permissionsLibrary) => ({
  jobsPermission: permissionsLibrary.jobsPermission(),
  resultsPermission: permissionsLibrary.resultsPermission(),
  moveEmailCandidatesPermission:
    permissionsLibrary.moveEmailCandidatesPermission(),
  baselinesPermission: permissionsLibrary.baselinesPermission(),
  batteriesPermission: permissionsLibrary.batteriesPermission(),
  analyticsPermission: permissionsLibrary.analyticsPermission(),
  usersTeamsPermission: permissionsLibrary.usersTeamsPermission(),
  accessRolesPermission: permissionsLibrary.accessRolesPermission(),
  companyPrefPermission: permissionsLibrary.companyPrefPermission(),
  integrationsPermission: permissionsLibrary.integrationsPermission(),
  documentsPermission: permissionsLibrary.documentsPermission(),
  testMakerPermission: permissionsLibrary.testMakerPermission(),
  jobAppsPermission: permissionsLibrary.jobAppsPermission(),
  pipelinesPermission: permissionsLibrary.pipelinesPermission(),
  emailTemplatesPermission: permissionsLibrary.emailTemplatesPermission(),
  ratingSystemsPermission: permissionsLibrary.ratingSystemsPermission(),
  landingPagesPermission: permissionsLibrary.landingPagesPermission(),
  exitPagesPermission: permissionsLibrary.exitPagesPermission(),
  collaboratorOnlyPermission: permissionsLibrary.collaboratorOnlyPermission(),
  interviewTemplatesPermission:
    permissionsLibrary.interviewTemplatesPermission(),
  competencySetsPermission: permissionsLibrary.competencySetsPermission(),
  accountBillingDetailsPagePermission:
    permissionsLibrary.accountBillingDetailsPagePermission(),
});

export const getBannedRoutes = (
  roles,
  userData,
  companyInfo,
  paidThisSession
) => {
  const {
    roleId = null,
    videoInterviewsEnabled,
    status,
    daysRemaining,
  } = userData;

  const accessLibrary = RolesAccessLibrary(roles, roleId);
  const bannedRoutes = [];
  if (!accessLibrary.jobsPermission()) {
    bannedRoutes.push("jobpost");
  }
  if (!accessLibrary.resultsPermission()) {
    bannedRoutes.push("results");
    bannedRoutes.push("resultslanding");
    bannedRoutes.push("search");
  }
  // if (!accessLibrary.moveEmailCandidatesPermission()) bannedRoutes.push('moveEmailCandidates');
  if (!accessLibrary.baselinesPermission()) {
    bannedRoutes.push("scoreranges");
  }
  if (!accessLibrary.batteriesPermission()) {
    bannedRoutes.push("testbatteries");
  }
  if (!accessLibrary.analyticsPermission()) {
    bannedRoutes.push("analytics");
    bannedRoutes.push("reports");
  }
  if (!accessLibrary.usersTeamsPermission()) {
    bannedRoutes.push("users");
    bannedRoutes.push("teams");
  }
  if (!accessLibrary.accessRolesPermission()) {
    bannedRoutes.push("accessroles");
  }
  if (!accessLibrary.companyPrefPermission()) {
    bannedRoutes.push("companypreferences");
  }
  if (!accessLibrary.integrationsPermission()) {
    bannedRoutes.push("integrations");
  }
  // if (!accessLibrary.documentsPermission()) bannedRoutes.push('documents');
  if (!accessLibrary.testMakerPermission()) {
    bannedRoutes.push("testmaker");
  }
  if (!accessLibrary.jobAppsPermission()) {
    bannedRoutes.push("jobapplications");
  }
  if (!accessLibrary.pipelinesPermission()) {
    bannedRoutes.push("pipelines");
  }
  if (!accessLibrary.emailTemplatesPermission()) {
    bannedRoutes.push("emailtemplates");
  }
  if (!accessLibrary.ratingSystemsPermission()) {
    bannedRoutes.push("ratings");
  }
  if (!accessLibrary.landingPagesPermission()) {
    bannedRoutes.push("landingpages");
  }
  if (!accessLibrary.exitPagesPermission()) {
    bannedRoutes.push("exitpages");
  }
  if (
    !accessLibrary.interviewTemplatesPermission() ||
    !videoInterviewsEnabled
  ) {
    bannedRoutes.push(
      "interviewtemplates",
      "interviewtemplates_form",
      "contentlibrary"
    );
  }
  if (!accessLibrary.competencySetsPermission()) {
    bannedRoutes.push("assessmentsettingsillustrait", "competencyset_form");
  }
  if (
    !accessLibrary.accountBillingDetailsPagePermission() ||
    status === "free_trial"
  ) {
    bannedRoutes.push("accountbillingdetails");
  }

  if (
    status === "subscriber" &&
    companyInfo.get("autoRenewalEligibility") &&
    companyInfo.get("autoRenewalEnabled") &&
    daysRemaining >= 0 &&
    !paidThisSession
  ) {
    bannedRoutes.push("subscribe", "payment");
  }

  if (!videoInterviewsEnabled) {
    bannedRoutes.push("reports_interview_data_form");
  }

  return bannedRoutes;
};
